import { render, staticRenderFns } from "./app-sidebar.vue?vue&type=template&id=7b848c8a&"
import script from "./app-sidebar.vue?vue&type=script&lang=js&"
export * from "./app-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./app-sidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VNavigationDrawer})
